import { render, staticRenderFns } from "./AssignDriverDialog.vue?vue&type=template&id=5540d820&"
import script from "./AssignDriverDialog.vue?vue&type=script&lang=js&"
export * from "./AssignDriverDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports